export class SearchModel {
    StartDate: string
    EndDate: string
    statusID: number
    statusValue: string
    leadTypeID: string
    leadTypeValue: string
    listID: number
    listName: string
    searchText: string
    EnrollmentKey: string
    PreEnrollmentID: number
    EnrollmentRecId: number
    SourceId: string
    PageSize: number = 20
    PageNumber: number = 1
    SortFields: string = ""
    FilterCriteria: string = ""
}